import { render } from "./AllocatedBackorderHistoryFilters.vue?vue&type=template&id=1e8c966e"
import script from "./AllocatedBackorderHistoryFilters.vue?vue&type=script&lang=js"
export * from "./AllocatedBackorderHistoryFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__